import { Method } from 'axios';
import { APICallV4 } from 'reactApp/api/APICall';

export class RemoveAlbumApiCall extends APICallV4 {
    _method = 'album/delete';
    _type: Method = 'post';
}
